import { FilterType, Filter, FilterKey } from 'api-paths-cas';
import { IGetFilterGroupsProps } from '../../types';
import { NotStartedSelections } from './types';

export const ActivityStatusOptions = [
  {
    label: 'Not started',
    value: NotStartedSelections.FALSE,
  },
  {
    label: 'Started',
    value: NotStartedSelections.TRUE,
  },
];

const key = FilterKey.ACTIVITY_STATUS;
export const getActivityStatusFilter = ({ activeFilters }: IGetFilterGroupsProps): Filter => {
  const filters = activeFilters[key] ?? [];
  const options = ActivityStatusOptions.map(({ label, value }) => {
    return {
      label,
      value,
      checked: filters.some(filter => filter === value),
    };
  });
  return {
    name: 'User activity status',
    key,
    type: FilterType.SELECT_ONE,
    showSearch: false,
    options: {
      SELECT_ONE: options,
    },
  };
};
